/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Sign_In_HeadingInputs */

const en_auth_sign_in_heading = /** @type {(inputs: Auth_Sign_In_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in to your account`)
};

const es_auth_sign_in_heading = /** @type {(inputs: Auth_Sign_In_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inicia sesión en tu cuenta`)
};

/**
* | output |
* | --- |
* | "Sign in to your account" |
*
* @param {Auth_Sign_In_HeadingInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const auth_sign_in_heading = /** @type {((inputs?: Auth_Sign_In_HeadingInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Sign_In_HeadingInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_auth_sign_in_heading(inputs)
	return en_auth_sign_in_heading(inputs)
});